module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/info_m-1cd1b727158a37d3099430051883d617.svg";